"use strict";
/* globals module */
/**
 * @module skillBatchRoute
 * @description Baasic Skill Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Skill Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../common");
var contracts_1 = require("../../core/contracts");
var SkillBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(SkillBatchRoute, _super);
    function SkillBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'profile/lookups/skills/batch';
        _this.updateRoute = 'profile/lookups/skills/batch';
        _this.deleteRoute = 'profile/lookups/skills/batch';
        return _this;
    }
    /**
     * Parses create route; this URI template does not expose any additional options.
     * @method
     * @example skillBatchRoute.create();
     **/
    SkillBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
      * Parses update route; this URI template does not expose any additional options.
      * @method
      * @example skillBatchRoute.update();
      **/
    SkillBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
      * Parses delete route; this URI template does not expose any additional options.
      * @method
      * @example skillBatchRoute.delete();
      **/
    SkillBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    SkillBatchRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], SkillBatchRoute);
    return SkillBatchRoute;
}(common_1.BaseRoute));
exports.SkillBatchRoute = SkillBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
